import React from "react";
import PropTypes from "prop-types";

import { Field, Control } from "rbx";

import "./PoorTextEditor.scss";
import "react-quill/dist/quill.snow.css";
import ReactQuill, { Quill } from "react-quill";

const Block = Quill.import("blots/block");
Block.tagName = "div";
Quill.register(Block);

const PoorTextEditor = ({ name, onChange, value, disabled }) => {
  const handleChange = content => {
    onChange({ target: { name, value: content } });
  };
  return (
    <Field className="poor-text-editor">
      <Control>
        <ReactQuill readOnly={disabled} value={value} onChange={handleChange} />
      </Control>
    </Field>
  );
};

PoorTextEditor.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

PoorTextEditor.defaultProps = {
  value: ""
};
export default PoorTextEditor;
